import React from "react";

const Footer = () => {
  return (
    <div id="footer">
    <div>BlockSignal ©2023 Created by BlockSignal.</div>
      </div>
  );
};

export default Footer;
